// extracted by mini-css-extract-plugin
export default {"container":"SettingsTables_container__UF-ru","tables":"SettingsTables_tables__ALFlz","report":"SettingsTables_report__3ZC9j"};